export const REQUEST_CASE_STUDY_ROWS = 'concrete/REQUEST_CASE_STUDY_ROWS'
export const RECEIVE_CASE_STUDY_ROWS = 'concrete/RECEIVE_CASE_STUDY_ROWS'
export const ERROR_CASE_STUDY_ROWS = 'concrete/ERROR_CASE_STUDY_ROWS'



// WEBPACK FOOTER //
// ./src/components/case-studies-container/action-types.js